<div mat-dialog-content>
  <p *ngFor="let message of messages" [innerHTML]="message" [attr.data-cy]="'mensagem-dialog'"></p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="handleConfirm()" color="primary" [attr.data-cy]="'button-confirmar-dialog'">{{confirmText}}</button>
  <button mat-raised-button *ngIf="showCancel" (click)="handleCancel()" color="primary" [attr.data-cy]="'button-cancelar-dialog'">{{cancelText}}</button>
</div>
